var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130.9 54",
    style: {
      enableBackground: "new 0 0 130.9 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.3,23.3c2-1.2,3.3-3.4,3.3-5.7c0-2.3-1.2-4.5-3.3-5.7L11,1.3c-1-0.6-2.1-0.9-3.3-0.9c-3.7,0-6.6,3-6.6,6.6 v33.1c0,3.7,3,6.6,6.6,6.6h6.7V31.9L29.3,23.3z M3.9,7.1c0-2.1,1.7-3.8,3.8-3.8c0.7,0,1.3,0.2,1.9,0.5l18.3,10.5 c1.2,0.7,1.9,1.9,1.9,3.3c0,1.4-0.7,2.6-1.9,3.3L4.3,34.5c-0.1,0.1-0.3,0.2-0.4,0.3c0,0,0,0,0,0V7.1z M11.6,33.6V44H7.7 c-2.1,0-3.8-1.7-3.8-3.8c0-1.4,0.7-2.6,1.9-3.3L11.6,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.6,43v-7.5c0-1.7-0.6-3-1.7-4c-1.1-1-2.6-1.4-4.5-1.4c-1.2,0-2.3,0.2-3.3,0.7c-1,0.4-1.8,1.1-2.4,1.8 c-0.6,0.8-0.9,1.6-0.9,2.5v0.2h3.1v-0.2c0-0.7,0.3-1.2,0.9-1.7c0.6-0.5,1.4-0.7,2.4-0.7c1.1,0,1.9,0.3,2.4,0.8 c0.5,0.5,0.8,1.3,0.8,2.2v1.1h-2.5c-2.4,0-4.2,0.5-5.5,1.4c-1.3,1-2,2.3-2,4.1c0,1.4,0.5,2.6,1.6,3.6c1.1,0.9,2.4,1.4,4,1.4 c1.7,0,3.2-0.6,4.5-1.8c0.1,0.7,0.2,1.1,0.4,1.4l0,0.1h3.2v-0.4l0-0.1C33.7,45.7,33.6,44.5,33.6,43z M28.8,43.9 c-0.7,0.4-1.6,0.7-2.4,0.7c-0.9,0-1.6-0.2-2.1-0.7c-0.5-0.5-0.8-1.1-0.8-1.9c0-1.9,1.6-2.8,4.9-2.8h2v3.1 C30.1,42.9,29.6,43.5,28.8,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.3,30.1c-1.9,0-3.4,0.7-4.6,2v-8.5h-3.1V47h3.1V35.3c0.4-0.7,0.9-1.3,1.5-1.8c0.6-0.5,1.4-0.7,2.3-0.7 c1.1,0,1.8,0.3,2.3,0.8c0.5,0.5,0.7,1.4,0.8,2.5V47h3.1V36.1C50.6,32.2,48.8,30.1,45.3,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.1,43v-7.5c0-1.7-0.6-3-1.7-4c-1.1-1-2.6-1.4-4.5-1.4c-1.2,0-2.3,0.2-3.3,0.7c-1,0.4-1.8,1.1-2.4,1.8 c-0.6,0.8-0.9,1.6-0.9,2.5v0.2h3.1v-0.2c0-0.7,0.3-1.2,0.9-1.7c0.6-0.5,1.4-0.7,2.4-0.7c1.1,0,1.9,0.3,2.4,0.8 c0.5,0.5,0.8,1.3,0.8,2.2v1.1h-2.5c-2.4,0-4.2,0.5-5.5,1.4c-1.3,1-2,2.3-2,4.1c0,1.4,0.5,2.6,1.6,3.6c1.1,0.9,2.4,1.4,4,1.4 c1.7,0,3.2-0.6,4.5-1.8c0.1,0.7,0.2,1.1,0.4,1.4l0,0.1h3.2v-0.4l0-0.1C67.3,45.7,67.1,44.5,67.1,43z M62.4,43.9 c-0.7,0.4-1.6,0.7-2.4,0.7c-0.9,0-1.6-0.2-2.1-0.7c-0.5-0.5-0.8-1.1-0.8-1.9c0-1.9,1.6-2.8,4.9-2.8h2v3.1 C63.7,42.9,63.1,43.5,62.4,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.6,30.1c-1.2,0-2.3,0.2-3.1,0.7c-0.8,0.4-1.5,1-2,1.7c-0.9-1.6-2.4-2.4-4.7-2.4c-1.9,0-3.5,0.6-4.7,1.8 l-0.1-1.5h-3V47h3.1V35c0.6-1.5,1.8-2.2,3.6-2.2c2.2,0,3.3,1.1,3.3,3.4V47h3.1l0-10.9c0.1-1,0.5-1.8,1.1-2.4 c0.6-0.6,1.5-0.9,2.4-0.9c1.2,0,2,0.3,2.5,0.8c0.5,0.5,0.7,1.4,0.7,2.5V47h3.1V36C94.1,32.1,92.3,30.1,88.6,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.9,24.5c-0.6,0-1,0.2-1.4,0.5c-0.3,0.3-0.5,0.8-0.5,1.3c0,0.5,0.2,0.9,0.5,1.2c0.3,0.3,0.8,0.5,1.4,0.5 c0.6,0,1-0.2,1.4-0.5c0.3-0.3,0.5-0.8,0.5-1.2c0-0.5-0.2-0.9-0.5-1.3C100.9,24.7,100.4,24.5,99.9,24.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.3,
    y: 30.4,
    className: "st0",
    width: 3.1,
    height: 16.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.4,23.3c-1.7,0-3.1,0.5-4.1,1.5c-1,1-1.4,2.4-1.4,4.2v1.5h-2.6v2.5h2.6V47h3.1V32.9h3.5v-2.5H110v-1.5 c0-0.9,0.2-1.7,0.7-2.1c0.5-0.5,1.1-0.7,2-0.7c0.5,0,1,0,1.5,0.1l0.2,0l0.2-2.6l-0.1,0C113.7,23.4,113,23.3,112.4,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.5,30.4l-3.7,11.8l-3.9-11.8h-3.4l5.8,16.2l-0.6,1.6c-0.3,1-0.7,1.6-1.2,2c-0.5,0.4-1.2,0.5-2.1,0.5 l-0.9-0.1v2.6l1.2,0.2l0.5,0c2.3,0,3.9-1.4,5-4.2l6.5-18.7l0.1-0.2H126.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.107c0e3bd99f7ff019c257697d4c3120.svg";
export { ForwardRef as ReactComponent };